import { Box, Button, Typography, useTheme, useMediaQuery } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import axios from 'axios';
import { Tooltip } from '@mui/material';
import { AuthContext } from '../../context/AuthContext';
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SettingsIcon from '@mui/icons-material/Settings';

const Customers = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [admins, setAdmins] = useState(null);
  const { currentuser, base_url, setRequest } = useContext(AuthContext);
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [pdfUrl, setPdfUrl] = useState('');

  const config = {
    headers: {
      'Authorization': `Bearer ${currentuser.accessToken}`
    },
    responseType: 'blob',
  };

  const fetchUsers = async () => {
    try {
      const response = await axios.post(`${base_url}/ethioglobal/customers/all`, config);
      setAdmins(response.data);

      // const res = await axios.get(`${base_url}/ethioglobal/docs/pdf/Shentam.pdf`, config);
      
      // const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
      // const pdfUrl = window.URL.createObjectURL(pdfBlob);
      // setPdfUrl(pdfUrl);
    } catch (error) {}
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const columns = [
    {
      field: "firstname",
      headerName: "First Name",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "lastname",
      headerName: "Last Name",
      flex: 1,
      hide: isSmallScreen,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    // {
    //   field: "dateofbirth", // Assuming this is the field for date of birth
    //   headerName: "Date of Birth",
    //   flex: 1,
    //   renderCell: (params) => {
    //     const dateOfBirth = new Date(params.value);
    //     const formattedDate = dateOfBirth.toLocaleDateString('en-US', {
    //       year: 'numeric',
    //       month: '2-digit',
    //       day: '2-digit',
    //     });
  
    //     return (
    //       <Tooltip title={formattedDate} arrow>
    //         <span>{formattedDate}</span>
    //       </Tooltip>
    //     );
    //   },
    // },
    // {
    //   field: "age",
    //   headerName: "Age",
    //   flex: 1,
    //   renderCell: (params) => {
    //     const dateOfBirth = new Date(params.row.dateofbirth); // Use the dateofbirth field
    //     const today = new Date();
    //     const age = today.getFullYear() - dateOfBirth.getFullYear();
  
    //     // Adjust age if the birthday hasn't occurred yet this year
    //     const monthDiff = today.getMonth() - dateOfBirth.getMonth();
    //     if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dateOfBirth.getDate())) {
    //       return age - 1;
    //     }
    //     return age;
    //   },
    // },
    {
      field: "membershiptype",
      headerName: "Type",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      hide: isSmallScreen,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "phonenumber",
      headerName: "Phone Number",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "createdAt",
      headerName: "Created Date",
      flex: 1,
      hide: isSmallScreen,
      renderCell: (params) => {
        const date = new Date(params.value);
        const formattedDate = date.toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit', // Use '2-digit' for numeric month
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
    
        return (
          <Tooltip title={formattedDate} arrow>
            <span>{formattedDate}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "id",
      headerName: "Details",
      flex: 1,
      // renderCell: (params) => (
      renderCell: (params) => {
        const { id } = params.row;

        return (
        <Tooltip title="Settings" arrow>
          <span
            style={{
              cursor: 'pointer',
              display: 'flex',
              marginRight: 10,
              alignItems: 'center',
              justifyContent: 'flex-end',
              height: '100%',
              width: '100%',
            }}
            onClick={ () => {
              setRequest(params.row);
              navigate(`/customer/${id}`)
            }}
          >
            <SettingsIcon />
          </span>
        </Tooltip>
      )},
    },
  ];

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header subtitle="Customers List" />
        {/* <Button 
          variant="contained" 
          color="primary" 
          onClick={() => navigate('/users/add')} // Replace with your route
        >
          New User
        </Button> */}
      </Box>
      <Box
        m="0px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        {admins !== null ? 
          <DataGrid 
            rows={admins} 
            columns={columns} 
            pageSize={5} 
            rowsPerPageOptions={[5]} 
            sx={{
              '& .overflow-cell': overflowCellStyle,
            }}
          />
          :
          <Typography>No rows to show.</Typography>
        }
      </Box>
      {/* {pdfUrl && (
        <Box mt="20px">
            <Typography variant="h6">Uploaded PDF:</Typography>
            <Box sx={{ border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden' }}>
            <iframe
                src={pdfUrl}
                style={{ width: '100%', height: '500px', border: 'none' }}
                title="Uploaded PDF"
                onLoad={() => console.log("PDF Loaded")}
                onError={() => console.error("Error loading PDF")}
            />
            </Box>
        </Box>
      )} */}
    </Box>
  );
};

const overflowCellStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export default Customers;